var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 17,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4762_11023",
    transform: "matrix(0.0156863 0 0 0.0166667 -0.205882 -0.25)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4762_11023",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC4klEQVR4nO3czWpTQRQH8JNj/agLXdilFkRXrpSCFOKZi+jCF/A1FCmKCHo3GnOm6aJLX8H3cCEtrQoqikHbl/CDtpFJjBVt4m3uzdyT3v8P7roz/57MRzJziQAAAAAAAAAAAAAAADJJ0im6+fyQ+bQupEeIUqaJcnn5BDt9wKLv2ekPdn6bxb9h0bs0vzRNVswvTbPz99jp224bnf/OTj+w+Pt0vXmSTLvqz7HoJ3a+s/ejr0laZ8puZmhD958/qJ3iP1LSOE8mzaXHWfznwSH7/tOmenO2tHbWm7OhDZnaaekT2MfiH2ZofKfUsLOH3P8EPiJr2PlX+wi6w6JfSBbPxh0uhg1re7ZxnUxJ0qlfE0r2TriIlb3vSv79bJtbjbDotxE60hl7ZY9SybuT4leyhkXXRuqMG2Nlj17J/TF6laxhp7dzBN0pPOzcIYdn8RaZM/fsMDv/IlfHpKBhJM9wsfu87O0YLUqap/NXkc9X2YVUsm+HvpBpRVSTjFjZZf7tUpTRYalayGV0XKoacswApOohxwhCEPL4AxGEPP7KFoQcZY3LZa/VJ4IUsmur+MRnPWypUshlhV3JkGOHXemQY4WNkCOEjZAjhI2QI4SNkP8DQUcgGDomL2SHIeRfWN5FINiwHJyQXZWHEcGXSgc3ZFelyq7ji//xE/yUNVkh9+F3w7/guEEEOEATAY6ERYBDjhHg2G4EOIgeQZIeY/ErJnZtUshycj3cBiZrehfYDYRc6FZfF8ia3tsMDtj1N/HvyJQby0dZdMtEJRd6oVO3bN3M6r77QnfMhZw7bN0Jcw9Zwk43TQwXxQ4jG2RNzelTc5Wcs7Jroo/JnKQ1k7Gq25PxYhTdpGuNU2SSa10aGrb4FRM3UrsbK10dOmQk/iKZlrRmas43QmP7MzeHF0Rd0TumJpawwXK6EJZwf6yYNmrin9it5EFCsKaWRwOENloqAgAAAAAAAAAAAAAAINN+Am3gFg5Zf++6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiply);
export default __webpack_public_path__ + "static/media/Multiply.ac1eb48cdfcccef9f667bc37f32e718b.svg";
export { ForwardRef as ReactComponent };